import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const conversationsService = {
    get,
    close,
    open,
    getCounters,
    assign,
    assignTeam,
    addCollaborator,
    removeCollaborator,
    addTag,
    removeTag,
    getInboxTeams,
    getArchivedCount,
    exportCSV,
    editBulk,
    create,
};

function get(params, pageToken = null, pageSize = 15) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    const nextPageToken = pageToken ? `&pageToken=${pageToken}` : '';
    return fetch(`${BASE_URL}api/inbox/conversations?${nextPageToken}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function create(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/new`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.ConversationStarted));
}

function close(conversationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:close`, requestOptions).then(handleResponse);
}

function open(conversationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:open`, requestOptions).then(handleResponse);
}

function getCounters(params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/counters`, requestOptions).then(handleResponse);
}

function getArchivedCount() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({}),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/archived`, requestOptions).then(handleResponse);
}

function assign(conversationId, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:assign`, requestOptions).then(handleResponse);
}

function assignTeam(conversationId, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:assign-team`, requestOptions).then(
        handleResponse,
    );
}

function addCollaborator(conversationId, userId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ userId }),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/collaborators`, requestOptions).then(
        handleResponse,
    );
}

function removeCollaborator(conversationId, userId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/collaborators/${userId}`, requestOptions).then(
        handleResponse,
    );
}

function addTag(conversationId, tagId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/tags/${tagId}`, requestOptions).then(
        handleResponse,
    );
}

function removeTag(conversationId, tagId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/tags/${tagId}`, requestOptions).then(
        handleResponse,
    );
}

function getInboxTeams() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/teams`, requestOptions).then(handleResponse);
}

function exportCSV(data, format = 'csv') {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/actions/export?format=${format}`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'conversations' }));
}

function editBulk(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/actions/edit`, requestOptions).then(handleResponse);
}
